import helper from "../helper";

let getPassOrderUrl = helper.getPassOrderUrlWithParameters
let getPassOrderAllowed = helper.allowedPassOrderUrl

export default {

    getByRecievedUrlData: (url, gets = null) => getPassOrderUrl(
        url.basename,
        url.action,
        url.params,
        gets
    ),
    ENTITLED: {
        ALLOWED: () => getPassOrderAllowed(
            "entitled|visitors|visitors-list",
            "list"
        ),
        REGULAR_ACTION_ALLOWED: () => getPassOrderAllowed(
            "entitled|visitors|regular|passes-list",
            "create"
        ),
        CHECK_ENTITLED_STATUS:
            (gets = null) => getPassOrderUrl(
                "base|orders|check|entitled",
                "get",
                null,
                gets
            ),
        FILE: {
            UNLOADING:
                (gets = null) => getPassOrderUrl(
                    "entitled|orders|orders-need-unloading",
                    "need_unloading",
                    {},
                    gets
                )
        },
        VISITORS: {
            LIST:
                (gets = null) => getPassOrderUrl(
                    "entitled|visitors|visitors-list",
                    "list",
                    null,
                    gets
                ),
            DETAIL:
                (id, gets = null) => getPassOrderUrl(
                    "entitled|visitors|visitors-detail",
                    "retrieve",
                    {id: id},
                    gets
                ),
            BLACK_LIST:
                (id, gets = null) => getPassOrderUrl(
                    "entitled|visitors|visitors-blacklist-status",
                    "blacklist_status",
                    {id: id},
                    gets
                )
        },
        ORDERS: {
            LIST:
                (gets = null) => getPassOrderUrl(
                    "entitled|orders|orders-list",
                    "list",
                    null,
                    gets
                ),
            DETAIL:
                (id, gets = null) => getPassOrderUrl(
                    "entitled|orders|orders-detail",
                    "retrieve",
                    {id: id},
                    gets
                ),
            AGREED:
                (id, gets = null) => getPassOrderUrl(
                    "entitled|orders|orders-agreed",
                    "agreed",
                    {id: id},
                    gets
                ),
            DISAGREED:
                (id, gets = null) => getPassOrderUrl(
                    "entitled|orders|orders-disagreed",
                    "disagreed",
                    {id: id},
                    gets
                ),
            CANCEL:
                (id, gets = null) => getPassOrderUrl(
                    "entitled|orders|orders-cancel",
                    "cancel",
                    {id: id},
                    gets
                ),
            UPDATE:
                (id, gets = null) => getPassOrderUrl(
                    "entitled|orders|orders-detail",
                    "update",
                    {id: id},
                    gets
                ),
            LOG_GUARD_POST:
                (id, gets = null) => getPassOrderUrl(
                "entitled|orders|orders-log",
                "log",
                {id: id},
                gets
                ),
            LOG_STATUS:
                (id, gets = null) => getPassOrderUrl(
                "entitled|orders|orders-statuses",
                "statuses",
                {id: id},
                gets
                ),
            FOULS:
                (gets = null) => getPassOrderUrl(
                "entitled|orders|order|fouls-list",
                "list",
                null,
                gets
                )
        },
        GUARD: {
            LOGIN:
                (gets = null) => getPassOrderUrl(
                    "entitled|orders|current|guard|login",
                    "get",
                    null,
                    gets
                ),
            CHAT_APPROVE:
                (gets = null) => getPassOrderUrl(
                    "entitled|chats|approve",
                    "get",
                    null,
                    gets
                ),
            POST: {
                LIST:
                    (gets = null) => getPassOrderUrl(
                        "entitled|visitors|guard|post-list",
                        "list",
                        null,
                        gets
                    ),
                DETAIL:
                    (id, gets = null) => getPassOrderUrl(
                        "entitled|visitors|guard|post-detail",
                        "retrieve",
                        {id: id},
                        gets
                    )
            },
            BUILDING: {
                LIST:
                    (post_id, gets = null) => getPassOrderUrl(
                        "entitled|visitors|guard|post|building-list",
                        "list",
                        {post_id: post_id},
                        gets
                    ),
                DETAIL:
                    (id, post_id, gets = null) => getPassOrderUrl(
                        "entitled|visitors|guard|post|building-detail",
                        "retrieve",
                        {post_id: post_id, id: id},
                        gets
                    )
            }
        },
        ORGANIZATIONS: {
            LIST:
                (gets = null) => getPassOrderUrl(
                    "entitled|visitors|organization-list",
                    "list",
                    null,
                    gets
                ),
            DETAIL:
                (id, gets = null) => getPassOrderUrl(
                    "entitled|visitors|organization-detail",
                    "retrieve",
                    {id: id},
                    gets
                ),
            CREATE:
                (gets = null) => getPassOrderUrl(
                    "entitled|visitors|organization-list",
                    "create",
                    null,
                    gets
                ),
            UPDATE:
                (id, gets = null) => getPassOrderUrl(
                    "entitled|visitors|organization-detail",
                    "partial_update",
                    {id: id},
                    gets
                ),
            DELETE:
                (id, gets = null) => getPassOrderUrl(
                    "entitled|visitors|organization-detail",
                    "destroy",
                    {id: id},
                    gets
                )
        },
        REGULAR_PASSES: {
            LIST:
                (gets = null) => getPassOrderUrl(
                    "entitled|visitors|regular|passes-list",
                    "list",
                    null,
                    gets
                ),
            DETAIL:
                (id, gets = null) => getPassOrderUrl(
                    "entitled|visitors|regular|passes-detail",
                    "retrieve",
                    {id: id},
                    gets
                ),
            CREATE:
                (gets = null) => getPassOrderUrl(
                    "entitled|visitors|regular|passes-list",
                    "create",
                    null,
                    gets
                ),
            UPDATE:
                (id, gets = null) => getPassOrderUrl(
                    "entitled|visitors|regular|passes-detail",
                    "partial_update",
                    {id: id},
                    gets
                ),
            DELETE:
                (id, gets = null) => getPassOrderUrl(
                    "entitled|visitors|regular|passes-detail",
                    "destroy",
                    {id: id},
                    gets
                )
        },
        ROLES: {
            BANS: {
                ALLOWED: () => getPassOrderAllowed(
                    "entitled|roles|bans-list",
                    "list"
                ),
                LIST:
                    (gets = null) => getPassOrderUrl(
                        "entitled|roles|bans-list",
                        "list",
                        null,
                        gets
                    ),
                DETAIL:
                    (id, gets = null) => getPassOrderUrl(
                        "entitled|roles|bans-detail",
                        "retrieve",
                        {id: id},
                        gets
                    ),
                CREATE:
                    (gets = null) => getPassOrderUrl(
                        "entitled|roles|bans-list",
                        "create",
                        null,
                        gets
                    ),
                UNBAN:
                    (id, gets = null) => getPassOrderUrl(
                        "entitled|roles|bans-unban",
                        "unban",
                        {id: id},
                        gets
                    ),
                UPDATE:
                    (id, gets = null) => getPassOrderUrl(
                        "entitled|roles|bans-detail",
                        "partial_update",
                        {id: id},
                        gets
                    ),
                DELETE:
                    (id, gets = null) => getPassOrderUrl(
                        "entitled|roles|bans-detail",
                        "destroy",
                        {id: id},
                        gets
                    )
            },
        }
    }
}
